module.exports = __webpack_public_path__ + "img/content-bg.50f1b50f.png";